import React from "react";
import { useTranslation } from "react-i18next";
import useGoogleCalendar from "../../../../utils/hooks/useGoogleCalendar";
import EAButton from "../Buttons/EAButton";
import { FcGoogle } from "react-icons/fc";
import { Exercise } from "../../../models/Exercise";

interface AddToGoogleCalendarProps {
  // Opcja 1: Bezpośrednie przekazanie obiektu Exercise
  exercise?: Exercise;

  // Opcja 2: Przekazanie poszczególnych parametrów wydarzenia
  title?: string;
  startTime?: number;
  endTime?: number;
  details?: string;

  // Opcje stylu i renderowania
  variant?: "filled" | "outlined" | "text";
  color?: "primary" | "secondary" | "error";
  iconOnly?: boolean;
  noMargins?: boolean;
  fullWidth?: boolean;
}

/**
 * Komponent przycisk do dodawania wydarzeń do Kalendarza Google
 */
const AddToGoogleCalendar: React.FC<AddToGoogleCalendarProps> = ({
  exercise,
  title,
  startTime,
  endTime,
  details,
  variant = "text",
  color = "primary",
  noMargins = false,
  fullWidth = false,
}) => {
  const { t } = useTranslation();
  const { generateGoogleCalendarUrl, generateGoogleCalendarUrlFromExercise } = useGoogleCalendar();

  // Sprawdzenie, czy mamy wszystkie niezbędne dane
  const hasRequiredData = (exercise && exercise.startTime && exercise.closeTime) || (title && startTime && endTime);

  if (!hasRequiredData) {
    return null;
  }

  // Generuj URL kalendarza
  let calendarUrl: string;
  if (exercise) {
    calendarUrl = generateGoogleCalendarUrlFromExercise(exercise);
  } else {
    calendarUrl = generateGoogleCalendarUrl(title as string, startTime as number, endTime as number, details);
  }

  // Obsługa kliknięcia - otwiera link do Kalendarza Google w nowym oknie
  const handleClick = () => {
    window.open(calendarUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <EAButton
      title={t("dodaj_do_kalendarza_google")}
      onClick={handleClick}
      variant={variant}
      color={color}
      startIcon={<FcGoogle />}
      noMargins={noMargins}
      fullWidth={fullWidth}
    />
  );
};

export default AddToGoogleCalendar;
